import React, { useState, useEffect } from "react";
import SubHeader from "../general/SubHeader";
import { Link } from "react-router-dom";

const Booking = ({vehicle}) => {
  // const [vehicle, setVehicle] = useState([]);
  //   const [vehicleName, setVehicleName] = useState("");
  const [bookingForm, setBookingForm] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    starting_point: "",
    destination_point: "",
    vehicle_name: "",
  });

  // Fetch vehicles data from backend
  // useEffect(() => {
  //   const fetchVehicles = async () => {
  //     try {
  //       const response = await fetch(
  //         "https://apis.anvifoundation.com/omanshi/get-vehicle"
  //       );
  //       const data = await response.json();

  //       if (response.ok) {
  //         setVehicle(data); // Store the fetched sites in state
  //       } else {
  //         console.error("Failed to fetch vehicles:", data);
  //       }
  //     } catch (error) {
  //       console.error("Error while fetching vehicles:", error);
  //     }
  //   };

  //   fetchVehicles();
  // }, []); // Empty dependency array means it runs once when the component mounts
  

  const handleBooking = (nameVehicle) => {
    // setVehicleName(nameVehicle);
    setFormData((prev) => ({ ...prev, vehicle_name: nameVehicle }));
    setBookingForm(true);
  };

  // Handle form data changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://apis.anvifoundation.com/omanshi/trip-details",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setResponseMessage(
          "Trip Details Submitted successfully. We will revert you soon."
        );
        setTimeout(() => {
          setResponseMessage("");
        }, 3000);
        setBookingForm(false); // Close the form on success
      } else {
        setResponseMessage("Booking failed. Please try again.");
        setTimeout(() => {
          setResponseMessage("");
        }, 3000);
      }
    } catch (error) {
      setResponseMessage(
        "Error while submitting the booking. Try again later."
      );
      console.error("Error while submitting booking:", error);
      setTimeout(() => {
        setResponseMessage("");
      }, 3000);
    }
  };

  return (
    <>
      <SubHeader message="Booking" />

      <section className="py-5 bg-light">
        <div className="container text-center">
          <p className="sec-subheading">Our Vehicles</p>
          <p className="sec-heading">Select Vehicle for Booking</p>

          <div className="row text-start mt-4">
            {vehicle.length > 0 ? (
              vehicle.map((vehicles) => (
                <div
                  key={vehicles.id}
                  className="col-lg-4 col-md-6 col-12 my-2"
                >
                  <div className="vehicle-area-outer">
                    <img
                      src={`https://apis.anvifoundation.com/uploads/${vehicles.vehicle_image}`}
                      className="img-fluid"
                      style={{ height: "16em" }}
                      alt="Exclusive Offers"
                    />
                    <p className="fw-semibold mt-3 mb-0 fs-5"><i className="fa-solid fa-car"></i> {vehicles.name}</p>

                    <p className="text-muted">
                    <i className="fa-solid fa-users"></i> {vehicles.seats} Seater <br />
                    <i className="fa-solid fa-snowflake"></i> AC</p>
                    
                      <p className="text-muted">
                      Cost per km: <strong>Negotiable</strong>
                      {/* Cost per km: ₹{vehicles.cost} */}
                      <br />
                      Description: {vehicles.description}
                      <br />
                      <b>
                        <span style={{ color: "red" }}>Note: </span>{" "}
                        Toll/Parking Charges are excluded and should be paid by
                        customers.
                      </b>
                    </p>
                    <div className="d-flex flex-wrap">
                      <button className="slider-btn rounded-pill px-3 py-2 mt-2 me-2" onClick={() => handleBooking(vehicles.name)}>Enquire <i className="fa-solid fa-book-open-reader"></i></button>
                      <p className="my-0 pt-3 me-2"><Link to='tel:8858633908' className="slider-btn rounded-pill px-3 py-2">Call Now <i className="fa-solid fa-phone"></i></Link></p>
                      <p className="my-0 pt-3"><Link to='https://wa.me/+919696359735' className="slider-btn rounded-pill px-3 py-2">WhatsApp <i className="fa-brands fa-whatsapp"></i></Link></p>
                    </div>

                  </div>
                </div>
              ))
            ) : (
              <p>No Vehicles available.</p>
            )}
          </div>
          {/* row ends */}
        </div>
      </section>

      {bookingForm && (
        <>
          <section
            className="booking-form px-lg-5 px-3 py-5"
            onClick={() => setBookingForm(false)}
          >
            <div
              className="booking-form-inner col-lg-8 mx-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <p className="sec-subheading">Fill Trip Details</p>

              <form className="row g-3 my-4" onSubmit={handleSubmit}>
                <div className="col-12">
                  <input
                    type="text"
                    className="form-input"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Your Name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="tel"
                    className="form-input"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    placeholder="Your Phone"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-input"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Your Email"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-input"
                    name="starting_point"
                    value={formData.starting_point}
                    onChange={handleInputChange}
                    placeholder="Starting Point"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <input
                    type="text"
                    className="form-input"
                    name="destination_point"
                    value={formData.destination_point}
                    onChange={handleInputChange}
                    placeholder="Destination Point"
                    required
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    className="form-input"
                    name="vehicle_name"
                    value={formData.vehicle_name}
                    placeholder="Vehicle"
                    disabled
                    required
                  />
                </div>

                <div className="col-12">
                  <button type="submit" className="slider-btn w-100">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </section>
        </>
      )}

      {responseMessage && (
        <div className="response-message d-flex justify-content-between">
          <p className="my-0 mx-auto">{responseMessage}</p>
          <p
            className="my-0 cursor-pointer"
            onClick={() => setResponseMessage(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </p>
        </div>
      )}
    </>
  );
};

export default Booking;
